module.exports = __webpack_public_path__ + "static/media/snowmanPreview.61d0fc5c.png";